import { startOfDay, subHours, subDays } from 'date-fns'
import {LAST_3H, LAST_24H, TODAY, LAST_7_DAYS, LAST_30_DAYS, CUSTOM} from './const'

export function getPresetDates (presetName, dateStart = null, dateEnd = null) {
  if (presetName === CUSTOM) {
    return { dateStart, dateEnd }
  }

  const now = new Date()
  const today = startOfDay(now)
  const dates = {
    dateStart: today,
    dateEnd: now
  }

  if (presetName === LAST_3H) {
    dates.dateStart = subHours(now, 3)
  } else if (presetName === LAST_24H) {
    dates.dateStart = subHours(now, 24)
  } else if (presetName === TODAY) {
    dates.dateStart = today
  } else if (presetName === LAST_7_DAYS) {
    dates.dateStart = subDays(today, 7)
  } else if (presetName === LAST_30_DAYS) {
    dates.dateStart = subDays(today, 30)
  }

  return dates
}
